// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"53fb63bf","667":"82d0b87a","771":"7c33d22d","787":"545aecf5","932":"615ac270"}[chunkId] + ".chunk.js";
};